<template>
  <div>
    <v-card class="pb-2">
      <v-card-title class="primary white--text">
        <span style="width: 100%"
          >Available Merge Fields
          <v-btn class="float-right" dark icon small @click="$emit('cancel')">
            <v-icon color="white--text" small>mdi-close</v-icon>
          </v-btn>
        </span>
      </v-card-title>
      <v-card-text class="pa-5 mt-2">
        <span>
          • Enclosed placeholders with curly braces. <br />
          • Placeholders are <b>CASE-SENSITIVE</b> <br />
          • No white spaces inside the curly braces to let data populate the
          placeholder(s) after merging.
        </span>
        <v-row>
          <v-col>
            <ag-grid-vue
              class="ag-theme-alpine"
              domLayout="autoHeight"
              :defaultColDef="defaultColDef"
              :columnDefs="columnDefs"
              :rowData="rowData1"
            ></ag-grid-vue>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";

export default {
  name: "TemplateFields",
  components: {
    AgGridVue
  },
  data: () => ({
    columnDefs: null,
    rowData1: [],
    rowData2: []
  }),
  beforeMount() {
    let vm = this;
    vm.columnDefs = [
      { headerName: "Data Name", field: "dataName" },
      { headerName: "Placeholder", field: "placeholder" }
    ];
    vm.rowData1 = [
      { dataName: "Wholesaler", placeholder: "{Wholesaler}" },
      { dataName: "FirstName", placeholder: "{FirstName}" },
      { dataName: "Customer Number/Account", placeholder: "{CustomerNo}" },
      { dataName: "Company", placeholder: "{Company}" },
      { dataName: "Balance", placeholder: "{Balance}" },
      { dataName: "Month", placeholder: "{Month}" },
      { dataName: "Year", placeholder: "{Year}" },
      { dataName: "MthFirst (First month Balance)", placeholder: "{MthFirst}" },
      { dataName: "MthCurr (Current month Balance)", placeholder: "{MthCurr}" },
      { dataName: "Current Month", placeholder: "{CurrentMonth}" }
    ];

    vm.defaultColDef = {
      resizable: true,
      flex: 1,
      autoHeight: true,
      autoWidth: true
    };
  }
};
</script>
<style scoped>
.col.inner-col {
  border: 1px solid #ccc;
}
</style>
